import { gql } from '@apollo/client';

export const BUYEREMAIL = gql`
mutation Mutation($url: String!) {
    sentEmail(url: $url)
  }
`;
